const errorHandling = (error) => {
    if(!error.response || !error.response.data){
        return { error: {"error": true, status: 500, message: "Ocorreu um erro no servidor. Tente novamente mais tarde."} }
    }
    return {error: error.response.data}
}

export default errorHandling;